export * from './queries';

export const paintSystemsKeys = {
  paintSystems: (indexName: string, query: string) => ['paintsystemFilters', indexName, query],
};
